import { z } from 'zod';

import {
  HIGH_LACTATE_ALERT_DURATION_VALUES,
  HIGH_LACTATE_ALERT_VALUES,
} from './constants';

export const patientSettingsSchema = z.object({
  displayLactateData: z.boolean(),
  highLactateAlert: z.boolean(),
  highLactateAlertAbove: z
    .number()
    .refine((v) => HIGH_LACTATE_ALERT_VALUES.includes(v), {
      message: 'Invalid lactate threshold',
    }),
  highLactateAlertDuration: z
    .number()
    .int()
    .refine((v) => HIGH_LACTATE_ALERT_DURATION_VALUES.includes(v), {
      message: 'Invalid duration',
    }),
});
